export default {
  SET_TOKEN: (state, token) => {
    state.token = token
  },

  SET_USER: (state, user) => {
    state.user = user
  },

  RESET: state => {
    // Object.assign(state, getDefaultState())
  },

  SELECT_ACCOUNT: (state, id) => {
    state.accountSelected = state.myProfile.accounts.find((account) => (account.id === id)) || defaultAccount
  },

  SELECT_TERMINAL: (state, id) => {
    state.terminalSelected = state.myProfile.terminals.find((terminal) => (terminal.id === id))
  },

  SELECT_TERMINAL_NAME: (state, name) => {
    state.terminalName = name
  },

  appReady (state, isReady) {
    state.appReady = isReady
  },

  setConnected (state, status) {
    state.connected = status
  },

  setDomain (state, domain) {
    state.domain = domain
  },

  error (state, message) {
    console.log('error set: ', message)
    const messageType = 'errors'
    _setMessages(state, messageType, message)
  },

  clearErrors (state, keys = '') {
    // the optional key argument is used to keep that specific message from being cleared.
    // the optional key is a comma seperated list ex: 'string1, string2, string3, etc.'

    if (keys && typeof state.errors === 'object') {
      const errorObjectKeys = Object.keys(state.errors)
      const keyArray = keys.split(',').map((value) => {
        return value.trim()
      })

      let newErrorObj = {}

      keyArray.forEach(key => {
        if (errorObjectKeys.includes(key)) {
          newErrorObj[key] = state.errors[key]
        }
      })

      state.errors = newErrorObj
    } else {
      state.errors = {}
    }
  },

  info (state, message) {
    console.log('set info')
    const messageType = 'info'
    _setMessages(state, messageType, message)
  },

  clearInfo (state, key = '') {
    // the optional key argument is used to keep that specific message from being cleared.
    if (key && typeof state.info === 'object') {
      state.info = state.info.key
    } else {
      state.info = {}
    }
  },

  success (state, message) {
    const messageType = 'successes'
    _setMessages(state, messageType, message)
  },

  clearSuccesses (state, key = '') {
    // the optional key argument is used to keep that specific message from being cleared.
    if (key && typeof state.successes === 'object') {
      state.successes = state.successes.key
    } else {
      state.successes = {}
    }
  },

  persistentMessages (state, message) {
    const messageType = 'persistentMessages'
    _setMessages(state, messageType, message)
  },

  clearPersistentMessages (state, key = '') {
    // the optional key argument is used to keep that specific message from being cleared.
    if (key && typeof state.persistentMessages === 'object') {
      state.persistentMessages = state.persistentMessages.key
    } else {
      state.persistentMessages = {}
    }
  },

  token (state, token) {
    state.token = token
  },

  waive (state, id) {
    state.waiveList.push(id)
  },

  deleteWaive (state, id) {
    delete state.waiveList[id]
  },

  selectAccount (state, name) {
    let id = state.accountMap[name]
    state.accountSelected = state.myProfile.accounts.find((account) => (account.id === id)) || defaultAccount
    state.accountNameSelected = name
  },

  setDefaultCardTerminal (state, terminalId) {
    state.myProfile.custom.default_card_terminal_id = terminalId
  },

  setDefaultAchTerminal (state, terminalId) {
    state.myProfile.custom.default_ach_terminal_id = terminalId
  },

  session (state, session) {
    state.force_change_password = session.force_change_password
    state.password_grace_period = session.password_grace_period
    state.permissions = session.permissions || {}
    state.token = true
    state.myProfile = session.user

    // pagination defaults per user
    if (state.myProfile.custom && typeof state.myProfile.custom === 'object' && Object.keys(state.myProfile.custom).length && state.myProfile.custom.hasOwnProperty('pagination')) {
      if (state.myProfile.custom.pagination.hasOwnProperty('rowsPerPage')) {
        state.paginationDefaults.rowsPerPage = state.myProfile.custom.pagination.rowsPerPage
      }
    }

    // @TODO Clean up this crap, single list of account, terminals, and single selected
    // eslint-disable-next-line
    state.accountMap = session.user.accounts.reduce((obj, item) => (obj[item.name] = item.account_id, obj), {})
    state.accountList = session.user.accounts.map((account) => account.name)

    // @TODO Use session from API to determine access?
    let terminalsCard = []
    let terminalsCardCanCharge = []
    let processorsCard = []
    let terminalsACH = []
    let terminalsACHCanCharge = []
    let processorsACH = []

    session.user.terminals.forEach(function (terminal) {
      let types = []
      try {
        const parsed = JSON.parse(terminal.type)
        types = parsed || []
      } catch (e) {
        if (terminal.type) {
          types.push(terminal.type)
        }
      }

      if (!types || !Array.isArray(types) || types.length === 0) {
        return
      }

      if (types.indexOf('ecom') > -1 && terminal.is_virtual === 1) {
        terminalsCard.push(terminal)
        if (terminal.can_charge) {
          terminalsCardCanCharge.push(terminal)
        }
        if (!processorsCard.includes(terminal.processor_id)) {
          processorsCard.push(terminal.processor_id)
        }
      }
      if (types.indexOf('retail') > -1 && terminal.is_virtual === 1) {
        terminalsCard.push(terminal)
        if (terminal.can_charge) {
          terminalsCardCanCharge.push(terminal)
        }
        if (!processorsCard.includes(terminal.processor_id)) {
          processorsCard.push(terminal.processor_id)
        }
      }
      if (types.indexOf('moto') > -1 && terminal.is_virtual === 1) {
        terminalsCard.push(terminal)
        if (terminal.can_charge) {
          terminalsCardCanCharge.push(terminal)
        }
        if (!processorsCard.includes(terminal.processor_id)) {
          processorsCard.push(terminal.processor_id)
        }
      }
      if (types.indexOf('ach') > -1 && terminal.is_virtual === 1) {
        terminalsACH.push(terminal)
        if (terminal.can_charge) {
          terminalsACHCanCharge.push(terminal)
        }
        if (!processorsACH.includes(terminal.processor_id)) {
          processorsACH.push(terminal.processor_id)
        }
      }
    })

    // state.terminalsCharge = session.user.terminal_charge_ids
    state.terminalsCard = terminalsCard
    state.terminalsCardCanCharge = terminalsCardCanCharge.reverse()
    state.terminalsCardProcessors = processorsCard
    state.terminalsACH = terminalsACH
    state.terminalsACHCanCharge = terminalsACHCanCharge.reverse()
    state.terminalsACHProcessors = processorsACH
  },

  logout (state) {
    state.force_change_password = false
    state.permissions = {}
    state.token = false
    state.myProfile = {
      email: state.myProfile.email
    }

    state.paginationDefaults = {
      sortBy: 'created',
      descending: true,
      rowsPerPage: 5
    }

    state.accountMap = []
    state.accountList = []
    state.accountSelected = {
      manager_password: ''
    }
    state.accountNameSelected = ''
    state.terminalSelected = {}
    state.terminalNameSelected = ''

    // state.terminalsVT = []
    state.terminalsCard = []
    state.terminalsCardCanCharge = []
    state.terminalsCardProcessors = []
    state.terminalsACH = []
    state.terminalsACHCanCharge = []
    state.terminalsACHProcessors = []
    state.waiveList = []

    state.fundingPreferences = {
      dateRange: 'mtd',
      customStartDate: null,
      customEndDate: null,
      selectedMerchantKsuids: []
    }
  },

  forceChangePassword (state, setTo) {
    state.force_change_password = setTo
  },

  setFundingDateRange (state, dateRange) {
    state.fundingPreferences.dateRange = dateRange
  },

  setFundingCustomDates (state, { startDate, endDate }) {
    state.fundingPreferences.customStartDate = startDate
    state.fundingPreferences.customEndDate = endDate
  },

  setFundingMerchantFilter (state, merchantKsuids) {
    state.fundingPreferences.selectedMerchantKsuids = merchantKsuids
  }
}

// Internal Functions

const defaultAccount = {
  permissions: {}
}

const _setMessages = (state, messageType, message) => {
  const obj = {...state[messageType]}
  let key, value

  if (typeof message === 'string') {
    key = `${messageType}-default`
    value = message
  } else {
    key = Object.keys(message)[0]
    value = message[Object.keys(message)[0]]
  }

  if (obj[key]) {
    delete obj[key]
  }

  obj[key] = value
  state[messageType] = obj
}



// WEBPACK FOOTER //
// ./src/store/mutations.js